import { StoreProfileModule } from './StoreProfile.module';

export * from './StoreProfileModuleProps';
export default StoreProfileModule;
